class imageSlider {
	constructor(config) {
		this.config = Object.assign({
			scope: '.image_slider',
			mute: '.toggleMuted'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('click', this.config.mute, this.toggleMuted.bind(this))
	}

	toggleMuted(event) {
		let $target = $(event.target);
		$target.toggleClass('unmuted');
		let video = $('.elementor-background-video-hosted')
		if (video.prop('muted')){
			video.prop('muted',false)
		}
		else{
			video.prop('muted',true)
		}
	}
}

export default new imageSlider;